export default __webpack_public_path__ + "static/media/mcblogo.2b57d289.jpg";